
<script>
import { mergeData } from 'vue-functional-data-merge'
import { QAvatar } from 'quasar'
export default {
  functional: true,
  props: {
    size: {
      type: String,
      default: '4em'
    },
    fontSize: {
      type: String,
      default: '0.8em'
    },
    icon: {
      type: String
    }
  },
  render (createElement, { props, data, children, parent }) {
    const menuNode = parent.$menuNode
    return createElement(QAvatar, mergeData({
      staticClass: 'shadow-1',
      class: menuNode.iconClass ?? 'text-primary',
      props: {
        ...props,
        icon: props.icon ?? menuNode.icon
      }
    }, data), children)
  }
}
</script>
